

import { ReactNode, Suspense, lazy } from 'react';
import { StripeuserPage } from './Stripeuser';

/**
 * lazyLoad
 * @param children
 * @returns
 */
export const lazyLoad = (children: ReactNode): ReactNode => <Suspense fallback={''}>{children}</Suspense>;

// 根路径：未登录跳转登录页，已登录跳转后台首页
export const LandingGate = lazy(() => import('./Landing/LandingGate'));
// 首页
export * as HomePage from './HomePage';
// Home
export const Home = lazy(() => import('./Home'));

export * as Heanuser from './Heanuser';

export * as Heanmenu from './Heanmenu'

export * as Heanrole from './Heanrole'

export * as Heanoperatelog from './Heanoperatelog'

export * as Stripeuser from './Stripeuser'

export * as Stripeurl from './Stripeurl'

export * as Stripeaccount from './Stripeaccount'

export * as Stripecheckout from './Stripecheckout'

export * as Stripechannel from './Stripechannel'

export * as Stripelog from './Stripelog'

export * as Syncstripelog from './Syncstripelog'

export * as Shippinginfo from './Shippinginfo'

export * as Payoutinfo from './Payoutinfo'

export * as Payoutinfodeduction from './Payoutinfodeduction'


export * as Paymentrecord from './Paymentrecord'

export * as Stripeblacklist from './Stripeblacklist'

export * as StShopify from './stshopify'

export * as Stripeusergroup from './Stripeusergroup'

export * as Heantenant from './Heantenant'

export * as Paymentmethod from './Paymentmethod'

export * as Stdraftorder from './Stdraftorder'

export * as Xpaydoc from './Xpaydoc'

export * as BaseDomain from './Basedomian'
















// Login
export const Login = lazy(() => import('./Sign/login'));

// Register
export const Register = lazy(() => import('./Sign/register'));

// Forget
export const Forget = lazy(() => import('./Sign/forget'));

export * as Transferorder from './Transferorder'